<script context="module">
    import cryptoJS from "crypto-js";
    import { DirectInsuranceType } from "./utilEnums.svelte";

    export const HTTP_STATUS = {
        NO_CONTENT: 204,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403,
        SERVER_TIMEOUT: 408,
        BAD_GATE_WAY: 502,
        SERVICE_UNAVAILABLE: 503,
        GATEWAY_TIMEOUT: 504,
    };

    export const SEARCH = {
        DEBOUNCE_TIME: 500,
        BILLING_RULE_AMOUNT_TIME: 100,
    };

    export const GOOGLE_MAP_CONFIG = {
        // PLACE_API_KEY: "AIzaSyCvIT-n49NWQ4oeFpt3VzrSylJjr3u5Png", // local env
        PLACE_API_KEY: "AIzaSyDvadWIiwltAvU0FXWI-BDCn8cpEXcoF6o", // stging n prod env
    };

    export const ADMIN_ID_CAN_EDIT_STATUS =
        process.env.ADMIN_ID_CAN_EDIT_STATUS ?? 1;

    export const ADMIN_EMAIL_CAN_EDIT_STATUS = "joseph.ziv@tcihealth.com.au";

    export const X_Device_ID =
        "d" +
        cryptoJS
            .MD5(
                `${navigator.appCodeName}-Anaemate-${navigator.hardwareConcurrency}-${navigator.language}-${navigator.oscpu}-${navigator.platform}-${navigator.userAgent}`,
            )
            .toString();

    export const noNeedForMedicareNoArr = [10, 15, 16, 17, 18, 20, 25, 26, 30];

    export const hideMedicareInsurance = [10, 18];

    // private, self-insured && dva encounter allows a Max. of 14 items
    export const insuranceTypesAllowLimitedAmountOfMbsItems = [0, 11, 20];

    // default encounter billing status 2, other default status 0
    export const defaultBillingStatusByInsuranceType = [16, 17, 20, 25, 26, 30];

    export const insuranceTypeHideQuoteSections = [16, 17, 20, 25, 26, 30];

    export const insuranceTypesNotAllowBillingRule = [20, 25];

    export const insuranceTypesMayAllowAmaBillingRule = [16, 17, 26];

    export const insuranceTypesAllowAsaItem = [10, 15];

    export const insuranceTypesMayAllowAsaItem = [16, 17];

    export const defaultErrorMsg = "Something went wrong.";

    export const defaultErrorMsgPrompt =
        "Please refresh the page and try again and contact support if the issue persists.";

    export const headerRightBtnCls =
        "btn btn-sm btn-secondary text-white items-center w-auto gap-x-[6px] py-[3px] px-[12px] capitalize";

    export const addIcon = "fa-regular fa-square-plus";

    export const editIcon = "fa-regular fa-pen-to-square";
    
    export const listIcon = "fa fa-list";

    export const deleteIcon = "fa-solid fa-trash-can";

    export const crossDeleteIcon = "fa-regular fa-circle-xmark";

    export const duplicateIcon = "fa-regular fa-copy";

    export const uploadIcon = "fa fa-cloud-upload";

    export const checkIcon = "fa-solid fa-check";

    export const eyeIcon = "fa-regular fa-eye";

    export const sendIcon = "fa-solid fa-paper-plane";

    export const downLoadIcon = "fas fa-download";
    
    export const historyIcon = "fas fa-history";
    
    export const infoIcon = "fas fa-circle-info";

    export const exportIcon = "fa-solid fa-file-export";

    export const infinityIcon = "fa-solid fa-infinity";

    export const unknownPatientInsuranceType = 100;

    export const managerHiddenEmailTemplates = [7, 8, 29, 38, 54];

    export const defaultAboutMe =
        "I qualified as a Fellow of the Australian and New Zealand College of Anaesthetists (FANZCA), and I maintain my professional knowledge and skills through the Australian and New Zealand College of Anaesthetists Continuing Professional Development program.";

    export const defaultPreOp =
        "My aim is to ensure you are cared for during your procedure and that any pain or discomfort is minimised afterwards. If you have any questions or concerns, I will be available to discuss them with you when I meet you before your procedure.";

    export const defaultCalendarEventColor = "#8A3ED7";

    export const MaxNumberOfTableLogs = 4;

    export const CheckFollowUpItemInterval = 5 * 60 * 1000; // 5 mins interval

    export const FollowUpPageRefreshInterval = 2 * 60 * 1000; // 2 mins interval

    export const NoteTypes = {
        Account: 0,
        Patient: 1,
        PatientEncounter: 2,
        Estimate: 3,
        Invoice: 4,
        Receipt: 5,
        AccountInvoice: 6,
        TopUpInvoice: 7,
        HealthFundInvoice: 8,
        AccountCalendarEvent: 9,
    };

    export const followUpRouteMap = {
        consentDue: "ConsentDue",
        patientPaymentsDue: "PatientPaymentDue",
        moreThan30Days: "FollowUp",
        claimError: "ClaimError",
        underPaid: "Underpaid",
        overPaid: "Overpaid",
    };

    export const followUpDisplayMap = {
        consentDue: "Consent Due",
        patientPaymentsDue: "Patient Payment Due",
        moreThan30Days: "> 30 Days",
        claimError: "Claim Error",
        underPaid: "Underpaid",
        overPaid: "Overpaid",
        pendingRefund: "Pending Refund",
        removedAndOnHold: "Removed and On Hold",
    };

    export const billingStatusDisplayMap = {
        PreQuote: "Pre Quote",
        Quoted: "Quoted",
        Ready: "Ready",
        Submitted: "Submitted",
        InProcess: "In Process",
        Completed: "Completed",
    };

    export const questionnairePropertyMap = {
        showHeightWeight: "Height and Weight",
        showAnaestheticHistory: "Anaesthetic History",
        showSurgicalHistory: "Surgical History",
        showMedications: "Medications",
        showPregnancy: "Pregnancy",
        showHeartConditions: "Heart Conditions",
        showNeurologicalConditions: "Neurological Conditions",
        showRespiratoryConditions: "Respiratory Conditions",
        showOtherConditions: "Other Conditions",
        showFunctionalAssessment: "Functional Assessment",
        showSubstanceUse: "Substance Use",
        showPatientFollowup: "Patient Callback",
        showPatientCallback: "Patient Callback",
    };

    export const graphIndicatorPeriodEnum = {
        daily: 0,
        weekly: 1,
        monthly: 2,
    };

    export const MinAccountNameLength = 2;

    export const FixedCalendarEventCategories = [
        "Leave",
        "List",
        "On Call",
        "Patient Encounter",
        "",
        "Global",
        "Public Holiday",
    ];

    export const DailyPlannerEventResizeBorderWidth = 4;

    export const FallBackGroupId = 0;

    export const FallBackEncounterDurationMins = 15;

    export const DirectCalendarEventTypes = {
        Leave: 0,
        List: 1,
        OnCall: 2,
        PatientEncounter: 3,
        Global: 5,
        PublicHoliday: 6,
    };

    export const DefaultLogsTraceBackDays = 90;

    export const InsuranceTypesBypassDisabledComms = [
        DirectInsuranceType.DefenceAMA,
        DirectInsuranceType.DefenceBupa,
        DirectInsuranceType.PublicInPrivate,
        DirectInsuranceType.WorkersCompensation,
        DirectInsuranceType.TrafficAccident,
        DirectInsuranceType.ThirdPartyInsurer,
    ];

    export const EmptyGroupDetails = {
        paperProcessingFee: Number(5),
        estimatesDefaultDueDays: Number(5),
        quotesOnlyDefaultDueDays: Number(30),
        invoicesDefaultDueDays: Number(5),
        insuranceInvoicesDefaultDueDays: Number(30),
        claimDelayHours: Number(24),
        preOpQuestionnaireNotifyDays: Number(3),
        preOpQuestionnaireTextInComm: "Complete your Pre-Op Questionnaire",
    };

    export const MaxPaperProcessingFee = 30;

    export const tooltipDisappearTimeDelayMS = 50;

    export const defaultAccountUnderpaymentThreshold = 0.05;

    export const proceduralSpecialtiesIds = [
        4, 5, 7, 31, 32, 33, 34, 35, 36, 37, 38, 39, 42, 46, 52, 53, 54, 55, 56,
        62, 73, 84, 85, 87, 99, 153, 157, 158, 606, 611, 808,
    ];

    export const checkPatientPaidPaymentsViaChangeEncounterStatus = [8];

    export const defaultTableRowBgColor = "bg-white";
</script>
